export default __webpack_public_path__ + "static-front/media/CopyIcon.a6a606e6.svg";